// Curated set of lucide-react icons available for the estate map.
// Keep in sync with MAP_ALLOWED_ICONS in backend/server.py.
import {
    MapPin, Baby, Car, Heart, Building2, Mail, Bike, Info,
    Trash2, Trees, Lightbulb, Key, Package, Dog, Dumbbell,
    Flame, Shield, Wrench, Droplet, Plug, Wifi, Camera,
    AlertTriangle, Accessibility, ParkingCircle, Bus, Coffee,
    ShoppingCart, Stethoscope, Phone, Wind, Sun, Lock,
} from "lucide-react";

export const ICON_MAP = {
    MapPin, Baby, Car, Heart, Building2, Mail, Bike, Info,
    Trash2, Trees, Lightbulb, Key, Package, Dog, Dumbbell,
    Flame, Shield, Wrench, Droplet, Plug, Wifi, Camera,
    AlertTriangle, Accessibility, ParkingCircle, Bus, Coffee,
    ShoppingCart, Stethoscope, Phone, Wind, Sun, Lock,
};

export const ICON_NAMES = Object.keys(ICON_MAP);

export function resolveIcon(name) {
    return ICON_MAP[name] || MapPin;
}
